export default __webpack_public_path__ + "static/media/pic2.92aff584.jpg";